import { render, staticRenderFns } from "./FzorganCertificateApplys.vue?vue&type=template&id=e92f8f7c&scoped=true&"
import script from "./FzorganCertificateApplys.vue?vue&type=script&lang=js&"
export * from "./FzorganCertificateApplys.vue?vue&type=script&lang=js&"
import style0 from "./FzorganCertificateApplys.vue?vue&type=style&index=0&id=e92f8f7c&scoped=true&lang=css&"
import style1 from "./FzorganCertificateApplys.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92f8f7c",
  null
  
)

export default component.exports